<div *ngIf="isReady && kpiDates" class="dash-kpi">
  <ng-container *ngIf="measure === 'count'">
    <div class="dash-kpi-values">
      <span class="dash-kpi-value">{{ amt | number }}</span>
      <span class="dash-kpi-pct">{{ pct === null ? '—' : (pct | number: '1.1-1') + '%' }}</span>
    </div>
    <div class="dash-kpi-label">Units shipped on time</div>
    <div class="dash-kpi-caption">of {{ totalAmt | number }} units shipped</div>
  </ng-container>
  <ng-container *ngIf="measure === 'value'">
    <div class="dash-kpi-values">
      <span class="dash-kpi-value">{{ amt | currency: 'USD' : 'symbol' : '1.0-0' }}</span>
      <span class="dash-kpi-pct">{{ pct === null ? '—' : (pct | number: '1.1-1') + '%' }}</span>
    </div>
    <div class="dash-kpi-label">Value shipped on time</div>
    <div class="dash-kpi-caption">of {{ totalAmt | currency: 'USD' : 'symbol' : '1.0-0' }} shipped</div>
  </ng-container>
  <div class="dash-kpi-caption">{{ rangeText }}</div>
</div>
<div *ngIf="isReady && !kpiDates" class="dash-kpi">
  <div class="dash-kpi-caption">Select a start date and an end date.</div>
</div>
<div *ngIf="!isReady" class="dash-kpi">
  <i class="pi pi-spin pi-spinner text-2xl"></i>
</div>
